export default __webpack_public_path__ + "static/media/audioOff.4d81daf4.svg";